import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/purchase_prices',
    name: 'PurchasePrices',
    component: {
      name: 'AdminPurchasePrice',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'purchase_price',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPurchasePriceIndex',
        component: () => import('../views/PurchasePriceAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPurchasePriceNew',
        component: () => import('../views/PurchasePriceAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPurchasePriceIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPurchasePriceShow',
        component: () => import('../views/PurchasePriceAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPurchasePriceIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPurchasePriceDetails',
            component: () => import('../views/PurchasePriceAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPurchasePriceIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPurchasePriceEdit',
            component: () => import('../views/PurchasePriceAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPurchasePriceDetails' },
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));